export default __webpack_public_path__ + "static/media/Cicor_Logo_Standard_Screen.adc0b210.jpg";